import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Dropdown,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import CustomNavbar from "../../../components/CustomNavbar";
import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";
import {
  getCompetencies,
  saveCompetencie,
  editCompetencie,
  deleteCompetencie,
} from "../../../redux/descriptorsProfiles/competencies/actions";
import { getDivision } from "../../../redux/division/actions";
import { getClassification } from "../../../redux/Classification/actions";
//import { get_tasks } from '../../../redux/tasks/actions';
import { getAreas } from "../../../redux/descriptorsProfiles/areas/actions";
import { getCompetenciesType } from "../../../redux/descriptorsProfiles/CompetenciesType/actions";
import {
  getCompetenciesDesc,
  resetCompetenciesDesc,
} from "../../../redux/descriptorsProfiles/competenciesDesc/actions";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";
import { Typeahead } from "react-bootstrap-typeahead";
import { get_tasks } from "../../../redux/tasks/actions";
import {
  getGeneralInfo,
  resetGeneralInfo,
} from "../../../redux/descriptorsProfiles/GeneralInfo/actions";
import { Link } from "react-router-dom";
// import {
//   getAreas as getAreasGestor,
//   getCarpetas
// } from "../../../redux/gestorDocumental/actions";
const schema = Yup.object().shape({
  funcion: Yup.string().required("**Campo requerido"),
  // descriptor: Yup.string().required("**Campo requerido"),
  // tipo_competencia: Yup.string().required("**Campo requerido"),
  area: Yup.string().required("**Campo requerido"),
  //funcion: Yup.string().ensure().required("**Campo requerido"),
  // division: Yup.string().ensure().required("**Campo requerido"),
  // clasificacion: Yup.string().ensure().required("**Campo requerido"),
  competencia: Yup.string().required("**Campo requerido"),
  // nombre: Yup.string().when("isEdit", {
  //   is: false,
  //   then: Yup.string().required("**Campo requerido"),
  // }),
  // descripcion: Yup.string().when("isEdit", {
  //   is: false,
  //   then: Yup.string().required("**Campo requerido"),
  // }),
  // subnivel1: Yup.string().when("isEdit", {
  //   is: false,
  //   then: Yup.string().required("**Campo requerido"),
  // }),
  // subnivel2: Yup.string().when("isEdit", {
  //   is: false,
  //   then: Yup.string().required("**Campo requerido"),
  // }),
  // archivo: Yup.mixed().when("isEdit", {
  //   is: false,
  //   then: Yup.mixed()
  //     .required("**Campo requerido")
  //     .test(
  //       "fileSize",
  //       "**El archivo es demasiado grande, es requerido un archivo menor o igual a 200 megabytes",
  //       (file) => (file ? !(file.size / 1024 > 200000) : false)
  //     ),
  // }),
  // descripcion: Yup.string()
  //   .matches(/[\w]/, "Formato no correcto")
  //   .required("**Campo requerido"),
  // fecha_vencimiento: Yup.string().required("**Campo requerido"),
  // estatus: Yup.string().required("**Campo requerido"),
  // numero_ticket: Yup.number().nullable().notRequired(),
  // id_workflow: Yup.string().nullable().notRequired(),
  // id_responsable_off: Yup.string().nullable().notRequired(),
  // categoria_desvinculacion: Yup.string().nullable().notRequired(),
});

const Competencies = (props) => {
  const filters = [
    {
      id: "competencia_nombre",
      desc: "Competencia",
    },
    {
      id: "tipo_competencia_descripcion",
      desc: "Tipo de competencia",
    },
    { id: "area_descripcion", desc: "Área" },
    // { id: "division_descripcion", desc: "División" },
    { id: "clasificacion_nombre", desc: "Clasificación" },
    { id: "descriptor_nombre", desc: "Descriptor" },
  ];
  //* States
  const [show, setShow] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [filter, setFilter] = useState("");
  const [editItem, setEditItem] = useState({});
  const [validated, setValidated] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  const [_funcion, setFuncion] = useState(false);
  const [funSelected, setFunSelected] = useState([]);
  //const [clasificacionId, setClasificacionId] = useState(null);
  // const [descSelected, setDescSelected] = useState([]);
  //* Redux
  // const division = useSelector((store) => store.division.division);
  // const divisionLoader = useSelector((store) => store.division.loading);
  // const classification = useSelector(
  //   (store) => store.classification.classification
  // );
  // const classificationLoader = useSelector(
  //   (store) => store.classification.loading
  // );
  const [_viewMessege, setViewMessege] = useState(false);
  const [descriptorCompleto, setDescriptorCompleto] = useState(false);
  const [_continue, setContinue] = useState(true);
  // const tasks = useSelector(store => store.tasks.tasks);
  // const tasksLoader = useSelector(store => store.tasks.saveLoader);
  const {
    loaderCompetencies,
    saveLoaderCompetencie,
    competencies,
    competenciesFaild,
    formcompetencieFaild,
  } = useSelector((store) => store.competencies);
  // const { loading, competenciesTypes } = useSelector(
  //   (store) => store.competenciesType
  // );
  const { loaderCompetenciesDesc, competenciesDesc } = useSelector(
    (store) => store.competenciesDesc
  );
  const { loaderAreas, areas } = useSelector(
    (store) => store.areasDescriptoresPerfiles
  );
  // const {
  //   loadingAreas,
  //   loadingCarpetas,
  //   loaderSubNiveles,
  //   carpetas,
  //   subNiveles,
  //   subNivelesError,
  // } = useSelector((store) => store.gestorDocumental);
  //const areasGD = useSelector((store) => store.gestorDocumental.areas);
  //* variables
  const dispatch = useDispatch();
  const pages = Math.ceil((competencies ? competencies.count : 0) / limit);

  const { generalInfos, generalInfosLength, generalInfoError } = useSelector(
    (store) => store.generalInfo
  );
  const loadingGeneralInfo = useSelector((store) => store.generalInfo.loading);
  const tasks = useSelector((store) => store.tasks.tasks);
  const tasksLoader = useSelector((store) => store.tasks.loader);

  let funcionOptions = [];
  tasks &&
    tasks.map((task) => {
      funcionOptions = [
        ...funcionOptions,
        {
          id: task.id,
          label: task.descripcion
            ? `${task.codigo} / ${task.descripcion.toUpperCase()}`
            : "",
          item: task,
        },
      ];
    });
  let descriptorOptions = [];
  generalInfos &&
    generalInfos.map((gen) => {
      descriptorOptions = [
        ...descriptorOptions,
        {
          id: gen.id,
          label: gen.nombre_posicion.toUpperCase(),
        },
      ];
    });

  const columns = [
    {
      id: "tipo_competencia",
      Header: "Tipo de competencia",
      Cell: (value) =>
        value.row.original.list_tipo_competencia &&
        value.row.original.list_tipo_competencia.length
          ? value.row.original.list_tipo_competencia[0].descripcion
          : null,
    },
    {
      id: "area",
      Header: "Área",
      Cell: (value) =>
        value.row.original.list_area && value.row.original.list_area.length
          ? value.row.original.list_area[0].descripcion
          : null,
    },
    // {
    //   id: "division",
    //   Header: "División",
    //   Cell: (value) =>
    //     value.row.original.list_division &&
    //     value.row.original.list_division.length
    //       ? value.row.original.list_division[0].descripcion
    //       : null,
    // },
    {
      id: "clasificacion",
      Header: "Clasificación",
      Cell: (value) =>
        value.row.original.list_Clasificacion &&
        value.row.original.list_Clasificacion.length
          ? value.row.original.list_Clasificacion[0].nombre
          : null,
    },
    {
      id: "competencia",
      Header: "Competencia",
      Cell: (value) =>
        value.row.original.list_competencia &&
        value.row.original.list_competencia.length
          ? value.row.original.list_competencia[0].nombre
          : null,
    },
    {
      id: "descriptor",
      Header: "Descriptor",
      Cell: (value) =>
        value.row.original.descriptor
          ? value.row.original.list_descriptor[0].nombre_posicion
          : null,
    },
    {
      id: "fecha_creacion",
      Header: "Fecha de creación",
      Cell: (value) =>
        moment(value.row.original.fecha_creacion).format("DD/MM/YYYY"),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
          {/* {value.row.original.list_archivo &&
          value.row.original.list_archivo.length > 0 ? (
            <LinkDescargaListGD
              id={value.row.original.list_archivo[0].id}
              filters={{
                email: email,
                id: value.row.original.list_archivo[0].id_documento,
                llave: value.row.original.list_archivo[0].llave,
              }}
              origen={value.row.original.list_archivo[0].origen}
              cType={value.row.original.list_archivo[0].contentTypeGD}
            />
          ) : null} */}
        </div>
      ),
    },
  ];
  //const { descriptoresPerfiles, email } = config.gestorDocumental;
  //* Method
  const _getCompetencies = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getCompetencies({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  useEffect(() => {
    dispatch(get_tasks({}));
    dispatch(getDivision({}, 2));
    //dispatch(getClassification({}, 2));
    //dispatch(get_tasks({}, 2));
    dispatch(getAreas({}));
    _getCompetencies();
    dispatch(getCompetenciesType({}));
    //dispatch(getCompetenciesDesc({}));
    // dispatch(getAreasGD());
    // dispatch(getCarpetas());
    //dispatch(getAreasGestor());
    //dispatch(getCarpetas());
  }, [dispatch]);

  // useEffect(() => {
  //   if (areasGD && areasGD.length > 0 && carpetas && carpetas.length > 0) {
  //     const oCarpeta = carpetas.find(
  //       (item) =>
  //         item.descripcion.toLowerCase() ===
  //         descriptoresPerfiles.competencias.carpeta.toLowerCase()
  //     );
  //     dispatch(
  //       getSubNivelesSancionesDocs({
  //         areaid: parseInt(areasGD[0].id),
  //         ceid: parseInt(oCarpeta.id),
  //       })
  //     );
  //   }
  // }, [areasGD, carpetas]);

  useEffect(() => {
    const _length = parseInt(generalInfos.length) - 1;
    if (
      _funcion &&
      generalInfos.length > 0 &&
      generalInfos[_length].clasificacion_empleado &&
      generalInfos[_length].descripcion_larga &&
      generalInfos[_length].list_division &&
      generalInfos[_length].list_empresa &&
      generalInfos[_length].genero &&
      generalInfos[_length].necesita_viajar &&
      generalInfos[_length].numero_personas_supervisa &&
      generalInfos[_length].proposito_general &&
      generalInfos[_length].list_unidad_organizativa
    ) {
      setDescriptorCompleto(true);
    } else {
      setDescriptorCompleto(false);
    }
  }, [generalInfos]);

  useEffect(() => {
    if (
      generalInfos &&
      generalInfos.length > 0 &&
      generalInfos[0].list_clasificacion_empleado &&
      generalInfos[0].list_clasificacion_empleado.length > 0
    ) {
      dispatch(
        getCompetenciesDesc({
          tipo_busqueda: "clasificacion_id",
          filter: generalInfos[0].list_clasificacion_empleado[0].id,
        })
      );
      //setClasificacionId(generalInfos[0].list_clasificacion_empleado[0].id);
      // if((clasificacionId !== generalInfos[0].list_clasificacion_empleado[0].id) || ){
      // }
    }
  }, [generalInfos]);

  const onAdd = () => {
    dispatch(resetCompetenciesDesc());
    dispatch(resetGeneralInfo());
    setFunSelected([]);
    setFuncion(false);
    // setDescSelected([]);
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
    setViewMessege(false);
    setContinue(true);
  };

  const onEdit = (item, index) => {
    if (item.descriptor) {
      setFunSelected([
        {
          id: item.list_descriptor[0].posicion,
          label: item.list_descriptor[0].list_posicion[0].descripcion
            ? `${
                item.list_descriptor[0].list_posicion[0].codigo
              } / ${item.list_descriptor[0].list_posicion[0].descripcion.toUpperCase()}`
            : "",
          item: item.list_descriptor[0].list_posicion[0],
        },
      ]);
      setFuncion(true);
      dispatch(
        getGeneralInfo({
          tipo_busqueda: "posicion_id",
          filter: parseInt(item.list_descriptor[0].posicion),
        })
      );
      // setDescSelected([
      //   {
      //     id: item.descriptor,
      //     label: item.list_descriptor[0].nombre_posicion,
      //   },
      // ]);
    }
    //  else {
    //   setFunSelected([]);
    //   setFuncion(false);
    // setDescSelected([]);
    // }
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
    setViewMessege(false);
    setContinue(true);
  };

  const ToggleableLink = (props) => {
    const { disabled, ...rest } = props;
    return disabled ? (
      <div
        className="btn btn-light rounded-pill"
        style={{ pointerEvents: "none", opacity: "0.8" }}
        disabled
      >
        {props.children}
      </div>
    ) : (
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip style={{ zIndex: 999999999999 }} {...props}>
            Descriptores de la función
          </Tooltip>
        }
      >
        <Link
          {...rest}
          className="btn btn-light rounded-pill d-flex flex-wrap justify-content-center align-items-center"
          style={{ textDecoration: "none" }}
          to={`/descriptores-perfiles/seleccion-del-descriptor/${
            funSelected.length > 0 ? funSelected[0].id : ""
          }/${funSelected.length > 0 ? funSelected[0].item.descripcion : ""}`}
          // target="_blank"
        >
          {props.children}
        </Link>
      </OverlayTrigger>
    );
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.search.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCompetencies(oOffset, limit, e.target.search.value);
  };

  const onSubmit = async (values) => {
    const lastElement = parseInt(generalInfos.length) - 1;
    const req = {
      descriptor: parseInt(generalInfos[lastElement].id),
      // tipo_competencia: values.tipo_competencia,
      area: parseInt(values.area),
      // division: values.division,
      // clasificacion: values.clasificacion,
      competencia: parseInt(values.competencia),
      // nombre: values.nombre,
      // descriptor: values.descripcion,
    };
    if (!edit) {
      dispatch(saveCompetencie(req, setShowFormModal));
    } else {
      dispatch(editCompetencie(editItem.id, req, index, setShowFormModal));
    }
    // try {
    //   let reqDoc = null;
    //   if (values.archivo) {
    //     const oCarpeta = carpetas.find(
    //       (item) =>
    //         item.descripcion.toLowerCase() ===
    //         descriptoresPerfiles.competencias.carpeta.toLowerCase()
    //     );
    //     const filebase64 = await getBase64(values.archivo);
    //     const fileName = values.archivo.name;
    //     const fName = String(fileName)
    //       .substring(0, String(fileName).lastIndexOf("."))
    //       .replace(/\W/g, "");
    //     const fExt = `.${String(fileName).substr(
    //       fileName.lastIndexOf(".") + 1 - fileName.length
    //     )}`;
    //     const aFileBase = String(filebase64).split(",");
    //     reqDoc = {
    //       id_area: parseInt(areasGD[0].id),
    //       id_carpeta_encabezado: parseInt(oCarpeta.id),
    //       subnivel1: values.subnivel1,
    //       subnivel2: values.subnivel2,
    //       medidas_disciplinarias: "",
    //       tipo_documento: descriptoresPerfiles.competencias.tipoDocumento,
    //       archivo: aFileBase[1],
    //       origen: fName + fExt,
    //       extension: fExt,
    //       contentTypeGD: `${aFileBase[0]},`,
    //       nombre: values.nombre,
    //       descripcion: values.descripcion,
    //     };
    //   }
    //   const lastElement = parseInt(generalInfos.length) - 1;
    //   const req = {
    //     reqDoc: reqDoc,
    //     req: {
    //       descriptor: parseInt(generalInfos[lastElement].division),
    //       tipo_competencia: values.tipo_competencia,
    //       area: values.area,
    //       // division: values.division,
    //       // clasificacion: values.clasificacion,
    //       competencia: values.competencia,
    //       nombre: values.nombre,
    //       descripcion: values.descripcion,
    //     },
    //   };
    //   if (!edit) {
    //     dispatch(saveCompetencie(req, setShowFormModal));
    //   } else {
    //     req.id = editItem.id;
    //     req.req.archivo = editItem.archivo;
    //     if (req.reqDoc) {
    //       req.reqDoc.id = editItem.list_archivo[0].id;
    //     }
    //     dispatch(editCompetencie(req, index, setShowFormModal));
    //   }
    // } catch (ex) {
    //   toastr.info("Error al subir archivo");
    //   return;
    // }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCompetencies(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteCompetencie(id, index));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SibebarDescriptorsProfiles show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              Competencias del descriptor
            </h5>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="search"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <Dropdown className="mx-3">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {competenciesFaild && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {competenciesFaild}
            </Alert>
          )}
          {loaderCompetencies ? (
            <div className="d-flex justify-content-center mt-4">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : competencies && competencies.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={competencies.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={competencies.count}
                pages={pages}
                pagFunc={_getCompetencies}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Sin registros que mostrar.
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            funcion: edit
              ? editItem.descriptor === null
                ? ""
                : editItem.list_descriptor[0].posicion
              : "",
            // descriptor: edit
            //   ? editItem.descriptor === null
            //     ? ""
            //     : editItem.descriptor
            //   : "",
            area: edit ? editItem.area : "",
            // tipo_competencia: edit ? editItem.tipo_competencia : "",
            // division: edit ? editItem.division : "",
            // clasificacion: edit ? editItem.clasificacion : "",
            competencia: edit ? editItem.competencia : "",
            // nombre: edit ? editItem.nombre : "",
            // descripcion: edit ? editItem.descripcion : "",
            // archivo: null,
            // subnivel1: edit
            //   ? editItem.list_archivo && editItem.list_archivo.length > 0
            //     ? editItem.list_archivo[0].subnivel1
            //     : ""
            //   : "",
            // subnivel2: edit
            //   ? editItem.list_archivo && editItem.list_archivo > 0
            //     ? editItem.list_archivo[0].subnivel2
            //     : ""
            //   : "",
            isEdit: edit,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {edit
                    ? "Editar Competencia del Descriptor"
                    : "Agregar Competencia al Descriptor"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {formcompetencieFaild &&
                typeof formcompetencieFaild !== "object" ? (
                  <Alert variant="danger" className="mt-2 mb-3">
                    {formcompetencieFaild}
                  </Alert>
                ) : null}
                {!loadingGeneralInfo &&
                _viewMessege &&
                _funcion &&
                generalInfos.length === 0 ? (
                  <div className="my-1 border-left border-danger">
                    <Alert variant="light">
                      <p>
                        No existe un descriptor para esta función, ¿Desea
                        agregar uno,{" "}
                        <Link
                          to={`/descriptores-perfiles/seleccion-del-descriptor/${
                            funSelected.length > 0 ? funSelected[0].id : ""
                          }/${
                            funSelected.length > 0
                              ? funSelected[0].item.descripcion
                              : ""
                          }`}
                          // target="_blank"
                        >
                          si
                        </Link>{" "}
                        o{" "}
                        <Link
                          onClick={() => {
                            setViewMessege(false);
                            setContinue(false);
                          }}
                        >
                          no
                        </Link>
                        ?
                      </p>
                    </Alert>
                  </div>
                ) : null}
                {!loadingGeneralInfo &&
                !descriptorCompleto &&
                _viewMessege &&
                _funcion &&
                generalInfos.length !== 0 ? (
                  <div className="my-1 border-left border-danger">
                    <Alert variant="light">
                      <p>
                        El descriptor para esta función no está completo, ¿Desea
                        completarlo ahora,{" "}
                        <Link
                          to={`/descriptores-perfiles/seleccion-del-descriptor/${
                            funSelected.length > 0 ? funSelected[0].id : ""
                          }/${
                            funSelected.length > 0
                              ? funSelected[0].item.descripcion
                              : ""
                          }`}
                          // target="_blank"
                        >
                          si
                        </Link>{" "}
                        o{" "}
                        <Link
                          onClick={() => {
                            setViewMessege(false);
                            setContinue(false);
                          }}
                        >
                          no
                        </Link>
                        ?
                      </p>
                    </Alert>
                  </div>
                ) : null}
                {!_continue ? (
                  <div className="my-1 border-left border-danger">
                    <Alert variant="light">
                      <p>Seleccione otra función para poder continuar.</p>
                    </Alert>
                  </div>
                ) : null}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Función
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={10}>
                        <Typeahead
                          id="funcion"
                          name="funcion"
                          isInvalid={touched.funcion && errors.funcion}
                          isValid={touched.funcion && !errors.funcion}
                          onBlur={handleBlur("funcion")}
                          placeholder="Función"
                          options={funcionOptions}
                          onChange={(selected) => {
                            setFieldValue(
                              "funcion",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setFunSelected(selected);
                            setFuncion(selected.length > 0);
                            if (selected.length > 0) {
                              setContinue(true);
                            }
                            setViewMessege(selected.length > 0);
                            if (selected.length > 0) {
                              dispatch(
                                getGeneralInfo({
                                  tipo_busqueda: "posicion_id",
                                  filter: parseInt(selected[0].id),
                                })
                              );
                            } else {
                              dispatch(resetGeneralInfo());
                            }
                          }}
                          selected={funSelected}
                          disabled={tasks.length === 0}
                        ></Typeahead>
                      </Col>
                      {tasksLoader || loadingGeneralInfo ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : (
                        <Col
                          sm={1}
                          className="d-flex flex-wrap justify-content-center align-items-center"
                        >
                          <ToggleableLink disabled={!_funcion}>
                            <i className="material-icons">description</i>
                          </ToggleableLink>
                        </Col>
                      )}
                    </Row>
                    {touched.funcion && errors.funcion && (
                      <Col>
                        <small className="text-danger">{errors.funcion}</small>
                      </Col>
                    )}
                    {!!generalInfoError && (
                      <Col>
                        <small className="text-danger">
                          **{generalInfoError}
                        </small>
                      </Col>
                    )}
                    {!tasksLoader && tasks.length === 0 && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron funciones
                        </small>
                      </Col>
                    )}
                    {/* {!loadingGeneralInfo &&
                      generalInfosLength === 0 &&
                      _funcion && (
                        <Col>
                          <small className="text-danger">
                            **No se encontraron descriptores para esta función.
                            <br />
                            **Agregue un descriptor para poder continuar.
                          </small>
                        </Col>
                      )} */}
                  </Col>
                </Form.Group>
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Función
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={tasksLoader ? "10" : "12"}>
                        <Typeahead
                          id="funcion"
                          name="funcion"
                          isInvalid={touched.funcion && errors.funcion}
                          isValid={touched.funcion && !errors.funcion}
                          onBlur={handleBlur("funcion")}
                          placeholder="Función"
                          options={funcionOptions}
                          onChange={(selected) => {
                            setFieldValue(
                              "funcion",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setFunSelected(selected);
                            setFuncion(selected.length > 0);
                            if (selected.length > 0) {
                              dispatch(
                                getGeneralInfo({
                                  tipo_busqueda: "posicion_id",
                                  filter: parseInt(selected[0].id),
                                })
                              );
                            }
                          }}
                          selected={funSelected}
                          disabled={tasks.length === 0}
                        ></Typeahead>
                      </Col>
                      {tasksLoader && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.funcion && errors.funcion && (
                      <Col>
                        <small className="text-danger">{errors.funcion}</small>
                      </Col>
                    )}
                    {!!generalInfoError && (
                      <Col>
                        <small className="text-danger">
                          **{generalInfoError}
                        </small>
                      </Col>
                    )}
                    {!tasksLoader && tasks.length === 0 && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron funciones
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Descriptor
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loadingGeneralInfo ? "10" : "12"}>
                        <Typeahead
                          id="descriptor"
                          name="descriptor"
                          isInvalid={touched.descriptor && errors.descriptor}
                          isValid={touched.descriptor && !errors.descriptor}
                          onBlur={handleBlur("descriptor")}
                          placeholder="Descriptor"
                          options={descriptorOptions}
                          onChange={(selected) => {
                            setFieldValue(
                              "descriptor",
                              selected.length > 0 ? selected[0].id : ""
                            );
                            setDescSelected(selected);
                          }}
                          selected={descSelected}
                          disabled={
                            !_funcion ||
                            generalInfosLength === 0 ||
                            loadingGeneralInfo
                          }
                        ></Typeahead>
                      </Col>
                      {loadingGeneralInfo && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.descriptor && errors.descriptor && (
                      <Col>
                        <small className="text-danger">
                          {errors.descriptor}
                        </small>
                      </Col>
                    )}
                    {!!generalInfoError && (
                      <Col>
                        <small className="text-danger">
                          **{generalInfoError}
                        </small>
                      </Col>
                    )}
                    {generalInfosLength === 0 && _funcion && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron descriptores para esta función
                        </small>
                      </Col>
                    )}
                    {!_funcion && (
                      <Col>
                        <small className="text-danger">
                          **Seleccione una función para mostrar descriptores
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group> */}
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Tipo de competencia
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loading ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          name="tipo_competencia"
                          className="rounded-pill"
                          disabled={loading}
                          required
                          value={values.tipo_competencia}
                          isInvalid={
                            touched.tipo_competencia &&
                            !!errors.tipo_competencia
                          }
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="" disabled selected>
                            Tipo de competencia
                          </option>
                          {competenciesTypes.length > 0
                            ? competenciesTypes.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.descripcion.toUpperCase()}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.tipo_competencia}
                        </Form.Control.Feedback>
                        {formcompetencieFaild &&
                        typeof formcompetencieFaild === "object" &&
                        formcompetencieFaild.tipo_competencia ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {formcompetencieFaild.tipo_competencia.map(
                              (item) => (
                                <li>{item}</li>
                              )
                            )}
                          </ul>
                        ) : null}
                      </Col>
                      {loading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group> */}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Área
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loaderAreas ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          name="area"
                          className="rounded-pill"
                          disabled={loaderAreas}
                          required
                          value={values.area}
                          isInvalid={touched.area && !!errors.area}
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="" disabled selected>
                            Área
                          </option>
                          {areas && areas.data
                            ? areas.data.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.descripcion.toUpperCase()}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.area}
                        </Form.Control.Feedback>
                        {formcompetencieFaild &&
                        typeof formcompetencieFaild === "object" &&
                        formcompetencieFaild.area ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {formcompetencieFaild.area.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      {loaderAreas && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                {/* <Form.Group as={Row}>
          <Form.Label column sm={3}>Función</Form.Label>
          <Col sm={9}>
            <Row>
              <Col sm={ tasksLoader ? '10': '12' }>
                <Form.Control
                  as="select"
                  id="funcion"
                  name="funcion"
                  className="rounded-pill"
                  disabled={edit && tasksLoader}
                  required
                  //value={}
                  onChange={ e => handleChange(e)}
                  placeholder="Función">
                    {
                      tasks ? tasks.map(item => (
                        <option key={item.id} value={item.id ? item.id : ''}>{item.descripcion ? `${item.codigo} / ${item.descripcion.toUpperCase()}` : ''}</option>
                      )) : null
                    }
                </Form.Control>
              </Col>
              {
                tasksLoader && (
                  <Col sm="2">
                    <Spinner animation="border" size="sm" />
                  </Col>
                )
              }
            </Row>
          </Col>
        </Form.Group> */}
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    División
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={divisionLoader ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          name="division"
                          className="rounded-pill"
                          disabled={edit && divisionLoader}
                          required
                          value={values.division}
                          isInvalid={touched.division && !!errors.division}
                          onChange={(e) => handleChange(e)}
                          placeholder="División"
                        >
                          <option value="" disabled selected>
                            División
                          </option>
                          {division
                            ? division.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id ? item.id : ""}
                                >
                                  {item.descripcion
                                    ? item.descripcion.toUpperCase()
                                    : ""}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.division}
                        </Form.Control.Feedback>
                        {formcompetencieFaild &&
                        typeof formcompetencieFaild === "object" &&
                        formcompetencieFaild.division ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {formcompetencieFaild.division.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      {divisionLoader && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Clasificación
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={classificationLoader ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          name="clasificacion"
                          className="rounded-pill"
                          disabled={edit && classificationLoader}
                          required
                          value={values.clasificacion}
                          isInvalid={
                            touched.clasificacion && !!errors.clasificacion
                          }
                          onChange={(e) => handleChange(e)}
                        >
                          <option value="" disabled selected>
                            Clasificación
                          </option>
                          {classification
                            ? classification.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id ? item.id : ""}
                                >
                                  {item.nombre ? item.nombre.toUpperCase() : ""}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.clasificacion}
                        </Form.Control.Feedback>
                        {formcompetencieFaild &&
                        typeof formcompetencieFaild === "object" &&
                        formcompetencieFaild.clasificacion ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {formcompetencieFaild.clasificacion.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      {classificationLoader && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group> */}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Competencia
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loaderCompetenciesDesc ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          name="competencia"
                          className="rounded-pill"
                          disabled={edit && loaderCompetenciesDesc}
                          required
                          value={values.competencia}
                          onChange={(e) => handleChange(e)}
                          isInvalid={
                            touched.competencia && !!errors.competencia
                          }
                        >
                          <option value="" disabled selected>
                            Clasificación - Tipo de competencia - Competencia
                          </option>
                          {competenciesDesc
                            ? competenciesDesc.data.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id ? item.id : ""}
                                >
                                  {item.list_clasificacion
                                    ? item.list_clasificacion[0].nombre.toUpperCase()
                                    : ""}{" "}
                                  -{" "}
                                  {item.list_tipo_competencia
                                    ? item.list_tipo_competencia[0].descripcion.toUpperCase()
                                    : ""}{" "}
                                  -{" "}
                                  {item.nombre ? item.nombre.toUpperCase() : ""}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.competencia}
                        </Form.Control.Feedback>
                        {formcompetencieFaild &&
                        typeof formcompetencieFaild === "object" &&
                        formcompetencieFaild.competencia ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {formcompetencieFaild.competencia.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      {loaderCompetenciesDesc && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                {/* <hr />
                <p className="text-muted">Archivo</p>
                <hr />
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Módulo
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loaderSubNiveles ? "10" : "12"}>
                        <Form.Control
                          disabled={loaderSubNiveles}
                          as="select"
                          name="subnivel1"
                          className="rounded-pill"
                          value={values.subnivel1}
                          onChange={handleChange}
                          isInvalid={touched.subnivel1 && !!errors.subnivel1}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar módulo
                          </option>
                          {subNiveles && Array.isArray(subNiveles.module)
                            ? subNiveles.module.map((subnivel) => (
                                <option
                                  key={subnivel.id}
                                  value={subnivel.descripcion}
                                >
                                  {subnivel.descripcion}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.subnivel1}
                        </Form.Control.Feedback>
                        {formcompetencieFaild &&
                        typeof formcompetencieFaild === "object" &&
                        formcompetencieFaild.subnivel1 ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {formcompetencieFaild.subnivel1.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      {loaderSubNiveles && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Tipo de archivo
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loaderSubNiveles ? "10" : "12"}>
                        <Form.Control
                          disabled={loaderSubNiveles}
                          as="select"
                          name="subnivel2"
                          className="rounded-pill"
                          value={values.subnivel2}
                          onChange={handleChange}
                          isInvalid={touched.subnivel2 && !!errors.subnivel2}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar tipo de archivo
                          </option>
                          {subNiveles && Array.isArray(subNiveles.files)
                            ? subNiveles.files.map((subnivel) => (
                                <option
                                  key={subnivel.id}
                                  value={subnivel.descripcion}
                                >
                                  {subnivel.descripcion}
                                </option>
                              ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.subnivel2}
                        </Form.Control.Feedback>
                        {formcompetencieFaild &&
                        typeof formcompetencieFaild === "object" &&
                        formcompetencieFaild.subnivel2 ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {formcompetencieFaild.subnivel2.map((item) => (
                              <li>{item}</li>
                            ))}
                          </ul>
                        ) : null}
                      </Col>
                      {loaderSubNiveles && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Nombre
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre}
                      placeholder="Nombre"
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre && !!errors.nombre}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre}
                    </Form.Control.Feedback>
                    {formcompetencieFaild &&
                    typeof formcompetencieFaild === "object" &&
                    formcompetencieFaild.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formcompetencieFaild.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Descripción
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      as="textarea"
                      name="descripcion"
                      required
                      value={values.descripcion} // 22
                      placeholder="Descripción"
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion}
                    </Form.Control.Feedback>
                    {formcompetencieFaild &&
                    typeof formcompetencieFaild === "object" &&
                    formcompetencieFaild.descripcion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formcompetencieFaild.descripcion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Archivo
                  </Form.Label>
                  <Col sm={9}>
                    <Form.File
                      accept="image/*,application/pdf,.xlsx,.xls,.csv,.doc,.docx"
                      className="mt-2 text-left position-relative"
                      name="archivo"
                      onChange={(e) =>
                        setFieldValue("archivo", e.currentTarget.files[0])
                      }
                      isInvalid={touched.archivo && !!errors.archivo}
                      feedback={errors.archivo}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.archivo}
                    </Form.Control.Feedback>
                    {formcompetencieFaild &&
                    typeof formcompetencieFaild === "object" &&
                    formcompetencieFaild.archivo ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formcompetencieFaild.archivo.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group> */}
                {/* {edit && editItem.list_archivo ? (
                  <>
                    <hr />
                    <Row>
                      <Col sm={3}>
                        <p className="text-muted">Documento actual</p>
                      </Col>
                      <Col sm={9}>
                        <LinkDescargaGD
                          id={editItem.list_archivo[0].id}
                          filters={{
                            email: email,
                            id: editItem.list_archivo[0].id_documento,
                            llave: editItem.list_archivo[0].llave,
                          }}
                          origen={editItem.list_archivo[0].origen}
                          cType={editItem.list_archivo[0].contentTypeGD}
                        />
                      </Col>
                    </Row>
                    <hr />
                  </>
                ) : null} */}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowFormModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={
                    saveLoaderCompetencie ||
                    loadingGeneralInfo ||
                    (!loadingGeneralInfo &&
                      generalInfosLength === 0 &&
                      _funcion) ||
                    (!loadingGeneralInfo &&
                      _funcion &&
                      generalInfos.length === 0) ||
                    (!loadingGeneralInfo && _funcion && !descriptorCompleto) ||
                    !_continue
                  }
                  variant="primary"
                  type="submit"
                >
                  {saveLoaderCompetencie && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Competencies;
